import { fromJS } from 'immutable';
import { appDb, regEventDb, toInterceptor, dispatch } from 'nike-re-framejs';
import { ENABLE_DEVELOPER_TOOLS, extractMiddlewareCtx } from './utils';

let devtools;

// umoznuje zobrazit reframe eventy a state v redux dev tools
export const connect_redux_devtools = () => {
    if (!ENABLE_DEVELOPER_TOOLS) {
        return;
    }

    let extension;
    try {
        extension = window.__REDUX_DEVTOOLS_EXTENSION__ || window.top.__REDUX_DEVTOOLS_EXTENSION__;
    } catch {}

    if (!extension) {
        return;
    }

    devtools = extension.connect();

    regEventDb('REDUX_DEVTOOLS/SET_STATE', [], (_, [, state]) => fromJS(state || {}));
    const setState = state => dispatch(['REDUX_DEVTOOLS/SET_STATE', JSON.parse(state)]);

    devtools.subscribe(message => {
        if (message.type === 'DISPATCH' && message.state) {
            switch (message.payload.type) {
                case 'JUMP_TO_ACTION':
                case 'JUMP_TO_STATE':
                    setState(message.state);
                    break;
            }
        }
    });

    devtools.init(appDb.peekValue().toJS());
};

export const reduxDevtoolsMiddleware = () =>
    toInterceptor({
        id: 'REDUX_DEVTOOLS_MIDDLEWARE',
        after: ctx => {
            try {
                const { eventName, eventArgs, db } = extractMiddlewareCtx(ctx);
                logReframeEventToReduxDevTools(eventName, eventArgs, db);
            } catch (e) {
                console.warn('reduxDevtoolsMiddleware failed to log', e);
            }
            return ctx;
        }
    });

export const logReframeEventToReduxDevTools = (eventName, eventArgs, newDb) => {
    if (!devtools || !eventName) {
        return;
    }

    try {
        devtools.send({ type: eventName, payload: eventArgs }, newDb);
    } catch (e) {
        console.warn('logReframeEventToReduxDevTools failed to log', e);
    }
};
